import { useAsyncData } from '@repo/ui/dataProvider'

import { Loader } from '@/components/beneficiary/list/Loader'
import {
  BeneficiaryListTable,
  BeneficiaryListTableChildren,
} from '@/components/beneficiary/list/table/Table'
import { getCurrentOrganization } from '@/store/helpers'
import { useStoreState } from '@/store/hooks'

export function BeneficiaryList({
  onSelectBeneficiary,
  children,
}: {
  onSelectBeneficiary?: () => void
} & BeneficiaryListTableChildren) {
  const { beneficiaries, sortOption, loading } = useStoreState((state) => state.beneficiaryList)

  const {
    data: [organization],
  } = useAsyncData([getCurrentOrganization])

  if (!organization) return null
  if (loading) return <Loader />
  return (
    <BeneficiaryListTable
      organization={organization}
      beneficiaries={beneficiaries}
      onSelectBeneficiary={onSelectBeneficiary}
      sortOption={sortOption}
    >
      {children}
    </BeneficiaryListTable>
  )
}
